import { User, AuthService, ApiService, TranslateService, TohumUiModule } from '@anadolu-commons/tohum-ui';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { UserPanelComponent } from '../shared/user-panel/user-panel.component';
import { map } from 'rxjs';
import { FuncsService } from '../services/funcs.service';
import { HttpClient, HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';
import { HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { OgrenciSecimComponent } from '../shared/ogrenci-secim/ogrenci-secim.component';
import { Moduller } from '../shared/ogrenci-secim/ogrenci-secim.model';
import { SafeHtmlPipe } from '../shared/safe-html/safe-html';


@Component({
  selector: 'app-ana-sayfa',
  standalone: true,
  imports: [CommonModule, RouterModule, TohumUiModule, UserPanelComponent, OgrenciSecimComponent, SafeHtmlPipe],
  templateUrl: './ana-sayfa.component.html',
  styleUrls: ['./ana-sayfa.component.scss']
})
export class AnaSayfaComponent implements OnInit, OnDestroy {

  user: User;
  profilId: string;
  adayBilgi: string;
  turkDiliVeKulturuBasvuruYapabilirMi: boolean = false;
  basvuruKartlari: any;
  turkiyeKartlar: any[] = [];
  yurtdisiKartlar: any[] = [];
  loading: boolean = true;
  currentLang: string;
  adminMi: boolean = false;
  yerineGirisMi: boolean = false;
  modalGoruntule: boolean = false;
  selectedCategory: 'turkiye' | 'yurtdisi' | null = null;
  basvuruVarMi: boolean = false;
  yurtdisiBasvuruVarMi: boolean = false;

  isMobileAdminResolution: boolean = false;
  moduller = Moduller;
  private idleCheckInterval: any;


  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private sharedService: SharedService,
    private translateService: TranslateService,
    private funcs: FuncsService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private tokenExtractor: HttpXsrfTokenExtractor,
    @Inject(DOCUMENT) private document: any
  ) {

    this.sharedService.profilAdSoyad$.subscribe((data) => {
      this.adayBilgi = data.ad + ' ' + data.soyad;
    });

    this.sharedService.profil$.subscribe((aday) => {
      this.profilId = aday.profilId;
      this.yerineGirisMi = this.sharedService.yerineGirisMi$;
    });
  }




  ngOnInit(): void {
    this.currentLang = this.translateService.getLang();
    this.checkResolution();
    this.user = this.authService.getUser();
    this.adminMi = this.authService.hasPermissions(['Admin']);
    this.turkDiliVeKulturuBasvuruYapabilirMi = this.authService.hasPermissions(["TurkDiliKulturuBasvurusu"]);
    this.sharedService.setBasvuruAsamasindaMi(false);

    this.kartlariGetir();

    // URL parametrelerini ve LocalStorage durumunu tek bir yerden, selectCategory metodunu tetikleyerek yönetelim
    this.route.queryParamMap.subscribe(params => {
      const k = params.get('k');
      const lang = params.get('lang');
      const tur = params.get('tur');

      // URL'den dil parametresi gelirse uygula
      if (lang && (lang === 'tr' || lang === 'en')) {
        if (this.currentLang !== lang) {
          this.currentLang = lang;
          this.translateService.setLang(lang);
          this.kartlariGetir();
        }
      }

      if (k === 'turkiye' || k === 'yurtdisi') {
        // Eğer URL'deki değer mevcut seçimden farklıysa tetikle
        if (this.selectedCategory !== k) {
          this.selectCategory(k as 'turkiye' | 'yurtdisi');
        }
      } else if (k === null || k === '') {
        // URL'de k yoksa LocalStorage'dan hatırla (30 dk kontrolü ile)
        const savedCategory = localStorage.getItem('selectedCategory');
        const lastActivityTime = localStorage.getItem('lastActivityTime');
        const now = Date.now();

        if (savedCategory && lastActivityTime) {
          const timeDiff = now - parseInt(lastActivityTime, 10);
          if (timeDiff < 30 * 60 * 1000) {
            if (this.selectedCategory !== savedCategory) {
              this.selectCategory(savedCategory as 'turkiye' | 'yurtdisi');
            }
          } else {
            this.selectedCategory = null;
            localStorage.removeItem('selectedCategory');
          }
        }
      }

      if (tur) {
        this.apiService.get('anasayfa/get-basvuru-kart-link', { kartId: tur })
          .subscribe(result => {
            this.basvuruYonlendir(result.data);
          });
      }
    });

    this.idleCheckInterval = setInterval(() => {
      const lastAct = localStorage.getItem('lastActivityTime');
      if (lastAct && this.selectedCategory) {
        const diff = Date.now() - parseInt(lastAct, 10);
        if (diff > 30 * 60 * 1000) {
          this.selectCategory(null);
        }
      }
    }, 60000);

    if (this.user && !this.sharedService.profilId$) {
      this.sorgula();
    }
  }



  ngOnDestroy(): void {
    if (this.idleCheckInterval) {
      clearInterval(this.idleCheckInterval);
    }
  }

  sorgula() {
    this.apiService.get('ogrenci-secimi/giris-yapan-aday-profil-sorgula/',
      {
        tcNo: this.user.id,
        girisYapanId: this.user.id,
        adminMi: false,
        kendiTcNoKullanmakIstiyor: true,
      })
      .pipe(
        map(json => json.data)
      )
      .subscribe(result => {
        this.sharedService.setProfilBilgi(result, false);
        this.sharedService.setAdSoyadBilgi(result);
      }, error => {
        this.funcs.hataMesajiVer(error);
      });
  }

  kartlariGetir() {
    this.apiService.get('anasayfa/get-basvuru-kartlari').
      subscribe(
        (res: any) => {
          this.basvuruKartlari = res.data;

          // Split data for mock/demo purposes (In real scenario, backend should provide categories)
          if (this.basvuruKartlari) {
            this.turkiyeKartlar = this.basvuruKartlari.turkiyeKartlar || [];
            this.yurtdisiKartlar = this.basvuruKartlari.yurtdisiKartlar || [];
            this.basvuruVarMi = this.basvuruKartlari.basvuruVarMi;
            this.yurtdisiBasvuruVarMi = this.basvuruKartlari.yurtdisiBasvuruVarMi;
          }

          this.loading = false;
        },
        err => {
          console.error("Kart Getirme Hatası:", err);
          this.loading = false;
          const status = err.statusCode || err.status;
          if (this.user && err && (status === 401 || status === 403 || status === 400)) {
            window.location.reload();
          }
        }
      );
  }

  basvuruYonlendir(url: string) {
    if (url && url.startsWith('http')) {
      window.open(url, '_blank');
      return;
    }

    if (!this.user) {
      this.sharedService.setReturnUrl(url);

      const token = this.tokenExtractor.getToken() as string;
      let headers = new HttpHeaders();
      if (token !== null) {
        headers = headers.append('X-XSRF-TOKEN', token);
      }
      this.http.get<any>('/auth/oauth/authorize', { headers }).subscribe(result => {
        this.document.location.href = result.data.redirectUrl;
      });
    } else {
      this.router.navigate([url]);
    }
  }

  ilkKayitYonlendir(url: string) {
    if (url && url.startsWith('http')) {
      window.open(url, '_blank');
      return;
    }

    if (!this.user) {
      this.sharedService.setReturnUrl(url);

      const token = this.tokenExtractor.getToken() as string;
      let headers = new HttpHeaders();
      if (token !== null) {
        headers = headers.append('X-XSRF-TOKEN', token);
      }
      this.http.get<any>('/auth/oauth/authorize', { headers }).subscribe(result => {
        // Appends Keycloak / OIDC registration query parameters (prompt=signup and action=register)
        // to guide the identity provider to display the sign-up/register page directly.
        this.document.location.href = result.data.redirectUrl + "&login_type=register";
      });
    } else {
      this.router.navigate([url]);
    }
  }

  get isLongName(): boolean {
    return this.adayBilgi ? this.adayBilgi.length > 30 : false;
  }


  selectCategory(kategori: 'turkiye' | 'yurtdisi' | null) {
    this.selectedCategory = kategori;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { k: kategori },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });

    if (kategori) {
      localStorage.setItem('selectedCategory', kategori);
      localStorage.setItem('lastActivityTime', Date.now().toString());
    } else {
      localStorage.removeItem('selectedCategory');
    }
  }

  setLang(lang: string) {
    this.currentLang = lang;
    this.translateService.setLang(lang);
    this.kartlariGetir();
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkResolution();
  }

  checkResolution() {
    if (typeof window !== 'undefined') {
      this.isMobileAdminResolution = window.innerWidth < 1064;
    }
  }

  modalKapat() {
    this.modalGoruntule = false;
  }

  logout() {


    const token = this.tokenExtractor.getToken() as string;
    let headers = new HttpHeaders();
    if (token !== null) {
      headers = headers.append('X-XSRF-TOKEN', token);
    }

    this.http.get<any>('/auth/oauth/logout', { headers }).subscribe(result => {
      this.document.location.href = result.data.redirectUrl;
    });
  }

  login() {
    const token = this.tokenExtractor.getToken() as string;
    let headers = new HttpHeaders();
    if (token !== null) {
      headers = headers.append('X-XSRF-TOKEN', token);
    }
    this.http.get<any>('/auth/oauth/authorize', { headers }).subscribe(result => {
      this.document.location.href = result.data.redirectUrl;
    });
  }
}
